import { render } from "./IdeaStatisticsView.vue?vue&type=template&id=2019aa42&scoped=true&ts=true"
import script from "./IdeaStatisticsView.vue?vue&type=script&lang=ts"
export * from "./IdeaStatisticsView.vue?vue&type=script&lang=ts"

import "./IdeaStatisticsView.vue?vue&type=style&index=0&id=2019aa42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2019aa42"]])

export default __exports__